import React from 'react';
import { Bell, LogOut, Search, Download, FileText, Clock, DollarSign, TrendingUp } from 'lucide-react';
import './Report.css';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';

export default function TimesheetReports() {
  return (
    <div className="consult-report-dashboard">
      {/* Header */}
      {/* <header className="consult-report-header">
        <div className="consult-report-header-left">
          <div className="consult-report-logo">
            <span className="consult-report-logo-icon" style={{width:'20px'}}><img src="/Images/Manurevalogo.png" alt="m"/></span>
            <span className="consult-report-logo-text">Manureva Digital Solutions</span>
          </div>
        </div>
        <div className="consult-report-header-right">
          <button className="consult-report-icon-btn">
            <Bell size={20} />
          </button>
          <div className="consult-report-user-profile">
            <div className="consult-report-user-info">
              <span className="consult-report-user-name">Gilbert Germain</span>
              <span className="consult-report-user-role">HR Manager</span>
            </div>
            <div className="consult-report-avatar">
              <img src="https://i.pravatar.cc/100?img=12" alt="User" />
            </div>
          </div>
          <button className="consult-report-icon-btn">
            <LogOut size={20} />
          </button>
        </div>
      </header> */}

      {/* Navigation Tabs */}
      {/* <nav className="consult-report-nav-tabs">
        <button className="consult-report-nav-tab">My Timesheet</button>
        <button className="consult-report-nav-tab consult-report-active">Reports</button>
      </nav> */}

      <div className="consult-header">
        <div className="consult-header-left">
          <div className="consult-logo-container">
            <div className="consult-logo"> <img src="/Images/Manurevalogo.png" alt="m"/> </div>
            <span className="consult-company-name">Manureva Digital Solutions</span>
          </div>
        </div>
        <div className="consult-header-right">
          <div className="consult-notification-icon" style={{color:'#fffff'}}><img src='/Images/notification.png' alt='🔔'/></div>
          <div className="consult-user-profile">
            <div className="consult-user-info">
              <span className="consult-user-name">Gilbert Germain</span>
              <span className="consult-user-role">HR Manager</span>
            </div>
            <div className="consult-user-avatar">👤</div>
          </div>
          <div className="consult-logout-icon"><PowerSettingsNewIcon/></div>
        </div>
      </div>

      {/* Navigation */}
      <div className="consult-navigation" style={{backgroundColor:'#ECEDF0'}}>
        <div className="consult-nav-item consult-active">My Timesheet</div>
        <div className="consult-nav-item">Reports</div>
      </div>

      {/* Main Content */}
      <main className="consult-report-main-content">
        <div className="consult-report-content-header">
          <h1 className="consult-report-page-title">Reports</h1>
          {/* <div className="consult-report-search-box">
            <Search size={18} />
            <input type="text" placeholder="Search for..." />
          </div> */}
        </div>

        {/* Filters */}
        <div className="consult-report-filters-section">
          <div className="consult-report-filters">
            <select className="consult-report-filter-select">
              <option>Client Billing Summary</option>
              <option>Project Overview</option>
              <option>Time Entry Details</option>
              <option>Utilization Report</option>
              <option>Invoice Summary</option>
            </select>
            <select className="consult-report-filter-select">
              <option>This Month</option>
              <option>Last Month</option>
            </select>
            <select className="consult-report-filter-select">
              <option>All Clients</option>
              <option>Axis Bank</option>
              <option>HDFC Bank</option>
              <option>State Bank of India</option>
            </select>
          </div>
          <div className="consult-report-action-buttons">
            <button className="consult-report-btn-secondary">
              <Download size={18} />
              Export Excel
            </button>
            <button className="consult-report-btn-primary">
              <FileText size={18} />
              Generate PDF
            </button>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="consult-report-stats-grid">
          <div className="consult-report-stat-card">
            <div className="consult-report-stat-header">
              <span className="consult-report-stat-label" style={{color:'#2196F3'}}>Total Hours </span>
              <div className="consult-report-stat-icon consult-report-blue">
                {/* <Clock size={20} /> */}
                <img src="/Images/Timesheet1.png" alt="Clock" />
              </div>
            </div>
            <div className="consult-report-stat-value">1,248</div>
            <div className="consult-report-stat-change consult-report-positive">+12% vs last month</div>
          </div>

          <div className="consult-report-stat-card">
            <div className="consult-report-stat-header">
              <span className="consult-report-stat-label" style={{color:'#009688'}} >Billable Hours</span>
              <div className="consult-report-stat-icon consult-report-green">
                <FileText size={20} />
              </div>
            </div>
            <div className="consult-report-stat-value">1,156</div>
            <div className="consult-report-stat-change consult-report-positive">92.6% billable rate</div>
          </div>

          <div className="consult-report-stat-card">
            <div className="consult-report-stat-header">
              <span className="consult-report-stat-label" style={{color:'#FF0004'}}>Revenue</span>
              <div className="consult-report-stat-icon consult-report-red">
                <img src="/Images/revenue.png" alt="DollarSign" />
                {/* <DollarSign size={20} /> */}
              </div>
            </div>
            <div className="consult-report-stat-value">$69,400.00</div>
            <div className="consult-report-stat-change consult-report-positive">+8% vs last month</div>
          </div>

          <div className="consult-report-stat-card">
            <div className="consult-report-stat-header">
              <span className="consult-report-stat-label" style={{color:'#FE7239'}} >Averag Rate</span>
              <div className="consult-report-stat-icon consult-report-orange">
                <img src="/Images/Averagerate.png" alt="TrendingUp" />
                {/* <TrendingUp size={20} /> */}
              </div>
            </div>
            <div className="consult-report-stat-value">$55.50</div>
            <div className="consult-report-stat-change consult-report-positive">+3% vs last month</div>
          </div>
        </div>

        {/* Table Section */}
        <div className="consult-report-table-header">
            <h2 className="consult-report-table-title">Client Billing Summary</h2>
            <p className="consult-report-table-subtitle">January 2025 • Billable hours and revenue breakdown</p>
          </div>
        <div className="consult-report-table-section">
          {/* <div className="consult-report-table-header">
            <h2 className="consult-report-table-title">Client Billing Summary</h2>
            <p className="consult-report-table-subtitle">January 2025 • Billable hours and revenue breakdown</p>
          </div> */}

          <div className="consult-report-table-container">
            <table className="consult-report-data-table">
              <thead>
                <tr>
                  <th>Client</th>
                  <th>Project</th>
                  <th>Hours</th>
                  <th>Rate</th>
                  <th>Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div className="consult-report-client-name">Axis Bank</div>
                    <div className="consult-report-client-code">AXIS</div>
                  </td>
                  <td>
                    <div className="consult-report-project-name">Loan Origination System</div>
                    <div className="consult-report-project-code">AXIS-LOS-2025</div>
                  </td>
                  <td>
                    <div className="consult-report-hours-value">23.5h</div>
                    <div className="consult-report-hours-type">billable</div>
                  </td>
                  <td>$60.00/hr</td>
                  <td className='consult-report-amount'>$1,410.00</td>
                  <td><span className="consult-report-status-badge consult-report-ready">Ready to Bill</span></td>
                </tr>
                <tr>
                  <td>
                    <div className="consult-report-client-name">HDFC Bank</div>
                    <div className="consult-report-client-code">HDFC</div>
                  </td>
                  <td>
                    <div className="consult-report-project-name">Mobile Banking App</div>
                    <div className="consult-report-project-code">HDFC-MOBILE-2025</div>
                  </td>
                  <td>
                    <div className="consult-report-hours-value">6h</div>
                    <div className="consult-report-hours-type">billable</div>
                  </td>
                  <td>$65.00/hr</td>
                  <td className='consult-report-amount'>$390.00</td>
                  <td><span className="consult-report-status-badge consult-report-ready">Ready to Bill</span></td>
                </tr>
                <tr>
                  <td>
                    <div className="consult-report-client-name">State Bank of India</div>
                    <div className="consult-report-client-code">SBI</div>
                  </td>
                  <td>
                    <div className="consult-report-project-name">Digital Banking Platform</div>
                    <div className="consult-report-project-code">SBI-DIGITAL-2025</div>
                  </td>
                  <td>
                    <div className="consult-report-hours-value">0h</div>
                    <div className="consult-report-hours-type">billable</div>
                  </td>
                  <td>$55.00/hr</td>
                  <td className='consult-report-amount'>$0.00</td>
                  <td><span className="consult-report-status-badge consult-report-ready">Ready to Bill</span></td>
                </tr>
                <tr className="consult-report-total-row">
                  <td style={{ font:'Albert Sans', weight:'500', size:'14px'}}>Total</td>
                  <td></td>
                  <td style={{Font:'Albert Sans',Weight:'700',Style:'Bold',Size:'14px'}} >29.5h</td>
                  <td>Mixed rates</td>
                  <td style={{Font:'Albert Sans',Weight:'700',Style:'Bold',Size:'14px'}} >$1,800.00</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </div>
  );
}